<ng-container *ngIf="!!get">
    <tt-card>
        <div style="display: flex; gap: 5px">
            <div class="flex-column flex-1">
                <tt-input-number
                    *ngIf="get.show_reported_progress_pst === '1'"
                    ttLabel="reported_progress_pst"
                    [(ttModel)]="get.reported_progress_pst"
                    (ttModelChange)="onChange('reported_progress_pst')"
                    ttTextAlign="right"
                    ttDecimals="4"
                ></tt-input-number>
                <tt-date
                    *ngIf="get.show_reported_progress_date === '1'"
                    ttLabel="date"
                    [(ttModel)]="get.reported_progress_date"
                    (ttModelChange)="onChange('reported_progress_date')"
                    ttTextAlign="right"
                ></tt-date>
                <tt-textarea *ngIf="get.show_reported_progress_note === '1'" ttLabel="note" [(ttModel)]="get.reported_progress_note"></tt-textarea>
                <tt-input-number
                    *ngIf="get.show_estimated_margin_pst === '1'"
                    ttLabel="estimated_margin_pst"
                    [(ttModel)]="get.estimated_margin_pst"
                    (ttModelChange)="onChange('estimated_margin_pst')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttFormatNumber
                ></tt-input-number>
                <tt-input-number
                    *ngIf="get.show_effect_of_accrual === '1'"
                    ttLabel="effect_of_accrual"
                    [ttModel]="get.effect_of_accrual"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttReadonly
                ></tt-input-number>
                <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
            </div>
            <tt-editor
                *ngIf="get.show_accrual_calculation_snapshot === '1'"
                class="tt-project-progress-log__editor"
                ttLabel="accrual_calculation_snapshot"
                [ttModel]="get.accrual_calculation_snapshot"
                ttReadonly
                ttHeight="100%"
            ></tt-editor>
        </div>
    </tt-card>
    <tt-grid *ngIf="!!grid" class="flex-1" style="min-height: 30rem" [(ttOptions)]="grid"></tt-grid>
</ng-container>
